import { BuildingCarrousel } from './BuildingCarrousel';

export type { TypeBuildingCarrouselProps } from './types';
export default BuildingCarrousel;
